"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDiscoverEventCallbacks = createDiscoverEventCallbacks;
function createDiscoverEventCallbacks(contextRef) {
    return {
        community_discover_viewed: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_discover_viewed', {
                context: 'community',
            });
        },
        community_discover_playlist_clicked: function (playlistId, position) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_discover_playlist_clicked', {
                context: 'community',
                playlist_id: playlistId,
                position: position,
            });
        },
        community_discover_video_clicked: function (clickedContentId, playlistId, position, contentTitle) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_discover_video_clicked', __assign({ context: 'community', content_id: clickedContentId, playlist_id: playlistId, position: position }, (contentTitle && { content_title: contentTitle })));
        },
        community_discover_refined: function (refinementValue) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            // Derive analytical properties from the raw refinement text rather than
            // sending the text itself — keeps user-typed content out of PostHog
            // (PII + cardinality risk; see notes above).
            var trimmed = refinementValue.trim();
            var wordCount = trimmed === '' ? 0 : trimmed.split(/\s+/).length;
            ctx.posthogClient.capture('community_discover_refined', {
                context: 'community',
                refinement_length: refinementValue.length,
                refinement_word_count: wordCount,
            });
        },
        community_discover_searched: function (isRefinement, refineTagCount) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_discover_searched', __assign({ context: 'community', is_refinement: isRefinement }, (refineTagCount != null && { refine_tag_count: refineTagCount })));
        },
        community_discover_search_completed: function (resultCount, hadResults, state) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_discover_search_completed', {
                context: 'community',
                result_count: resultCount,
                had_results: hadResults,
                state: state,
            });
        },
    };
}
